import { BigNumber } from 'bignumber.js';

const points = {
  A: 1,
  2: 2,
  3: 3,
  4: 4,
  5: 5,
  6: 6,
  7: 7,
  8: 8,
  9: 9,
  T: 0,
  J: 0,
  Q: 0,
  K: 0,
};
const patterns = ['C', 'D', 'H', 'S'];
const numbers = ['A', '2', '3', '4', '5', '6', '7', '8', '9', 'T', 'J', 'Q', 'K'];

class Card {
  constructor(pattern, number) {
    this.pattern = pattern;
    this.number = number;
  }

  toString() {
    return `${this.number}${this.pattern}`;
  }

  get point() {
    return points[this.number];
  }

  static get points() {
    return points;
  }

  static get patterns() {
    return patterns;
  }

  static get numbers() {
    return numbers;
  }
}

// Creating Deck

export const deckCount = 6;

// shuffle
const fisherYates = (seed, initialDeck) => {
  const shuffledDeck = Object.assign(initialDeck);

  for (let i = initialDeck.length - 1; i > 0; i -= 1) {
    const index = seed.mod(i, 10);

    // swap
    const tmp = shuffledDeck[index];
    shuffledDeck[index] = shuffledDeck[i];
    shuffledDeck[i] = tmp;
  }

  return shuffledDeck;
};

// create deck
const getInitialDeck = count => {
  const deck = [];
  for (let i = 0; i < count; i += 1) {
    // eslint-disable-next-line no-restricted-syntax
    for (const pattern of Card.patterns) {
      // eslint-disable-next-line no-restricted-syntax
      for (const number of Card.numbers) {
        deck.push(new Card(pattern, number));
      }
    }
  }
  return deck;
};

// create deck and shuffle
export const shuffle = (seed, count) => {
  BigNumber.config({ RANGE: 80 });
  const seedInteger = new BigNumber(seed, 16);

  return fisherYates(seedInteger, getInitialDeck(count));
};

// Result

const BaccaratResult = Object.freeze({
  Player: 'P',
  Banker: 'B',
  Tie: 'T',
  PlayerPair: 'PP',
  BankerPair: 'BP',
});

const getPoint = cards => cards.reduce((accu, card) => accu + card.point, 0) % 10;

const isPair = areaCards => areaCards[0].number === areaCards[1].number;

const getResult = (players, bankers) => {
  const result = [];
  const player = getPoint(players);
  const banker = getPoint(bankers);

  if (player === banker) result.push(BaccaratResult.Tie);
  else if (player > banker) result.push(BaccaratResult.Player);
  else result.push(BaccaratResult.Banker);

  if (isPair(bankers)) result.push(BaccaratResult.BankerPair);
  if (isPair(players)) result.push(BaccaratResult.PlayerPair);

  return result;
};

const isNatural = (players, bankers) => getPoint(players) >= 8 || getPoint(bankers) >= 8;

const isPlayerMoreCard = cards => getPoint(cards) < 6;

const isBankerMoreCard = (players, bankers) => {
  if (players.length === 2) return isPlayerMoreCard(bankers);
  if (getPoint(bankers) <= 2) return true;
  if (getPoint(bankers) === 3) return ['T', 'J', 'Q', 'K', 'A', '2', '3', '4', '5', '6', '7', '9'].includes(players[2].number);
  if (getPoint(bankers) === 4) return ['2', '3', '4', '5', '6', '7'].includes(players[2].number);
  if (getPoint(bankers) === 5) return ['4', '5', '6', '7'].includes(players[2].number);
  if (getPoint(bankers) === 6) return ['6', '7'].includes(players[2].number);
  return false;
};

const getScenario = (players, bankers) => JSON.stringify({
  player: players.map(player => player.toString()).join(''),
  banker: bankers.map(banker => banker.toString()).join(''),
});

const getReturn = (players, bankers) => [
  getScenario(players, bankers),
  getPoint(players),
  getPoint(bankers),
  getResult(players, bankers),
];

export const getNextResult = cardsDecks => {
  const players = [];
  const bankers = [];

  players.push(cardsDecks.shift());
  bankers.push(cardsDecks.shift());
  players.push(cardsDecks.shift());
  bankers.push(cardsDecks.shift());

  // Natural processing
  if (isNatural(players, bankers)) return getReturn(players, bankers);

  // Player additional card
  if (isPlayerMoreCard(players)) players.push(cardsDecks.shift());

  // Banker additional card
  if (isBankerMoreCard(players, bankers)) bankers.push(cardsDecks.shift());

  // calculate result
  return getReturn(players, bankers);
};
